import React from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Router from 'next/router';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  cleanText, cdnApi, getPodcastImgSize, getEpisodePaginationMap, episodesPerFetch, podcastSlugUrl,
  getDescription, isLocalStoragePresent, getCurrentPodcastData, setEpisodePagination, cleanGUID, filterPersonalValues, sortPersonalValuesGuidDesc, isEpisodeExplicitlyMarkedPlayed, getUUID, appleStoreUrl, playStoreUrl, retrieveLocally, saveLocally, staticAssetsPrefix,
  bookImage,
  isAdmin,
  isMagazine,
  isNews,
  stringToDateDay,
  bookProgressStage,
  bookVideoThumbFromRaw,
  bookVideoFromRawId,
  isBook,
  isSleep,
  secToTime,
  ratingDisplay
} from '../lib/utils';
// import { getBackButtonCache, setBackButtonCache } from '../lib/fileUtils';
import { spacing, minImageWidth, colors, fontSize, fixedSpacing, maxScreenSize } from '../lib/theme';
// import DOMPurify from 'dompurify';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NextSeo } from 'next-seo';
import memoizeOne from 'memoize-one';

import fetchJsonp from 'fetch-jsonp';
import { throttle } from '../lib/debounce';
import Img from 'react-image';
import { initStore } from '../store';

import { tokenFetch } from '../lib/tokenUtils';
import { convertRSSToJsonLatest, convertRSSToJsonLatestFirestore, convertRSSToJsonMore } from '../lib/rss2json';
// import { getItunesDataByCollectionId, getItunesDataServerByCollectionId } from '../lib/searchItunes';
import ExpandCollapse from '../components/ExpandCollapse';
import PodcastEpisode from '../components/Podcast/PodcastEpisode';
import InvalidPodcast from '../components/Podcast/InvalidPodcast';
import PodcastHeader from '../components/Podcast/PodcastHeader';
import AppShare from '../components/Common/AppShare';

import UnsignedInfo from '../components/UnsignedInfo';
import { CloseCircleOutlined, LoadingOutlined, SettingOutlined } from '@ant-design/icons';
import { Affix, Breadcrumb, Button, Col, Dropdown, Input, Menu, Modal, message, notification, Row, Spin, Tag } from 'antd';
import SubscribeOption from '../components/Podcast/SubscribeOption';
import EpisodeSkeleton from '../components/Podcast/EpisodeSkeleton';
import {
  getPodcastDataDB, getPodcastData, logPodcastWithItunesData, searchInSeries, setAllEpisodesAsPlayed, addToAutoQueueInfo,
  getAllEpisodesInSeries, getEpisodesDataFromGUIds, getEpisodeDataFromDocId, getPopularEpisodesInSeries, fetchRelatedProducts, fetchRelatedPodcasts, loadMostRecentEpisodeInSeries, getRecentEpisodesInSeries,
  markBookChecked,
  editBookDescription,
  getTokenRawCount,
  markChapterImagesDone,
  getPodcastIdFromShortLink
} from '../actions';
import { logViewSearchResults, logPodcastSeriesClick } from '../lib/analyticsEvents';


const defaultVal = {
  title: '',
  image: '',
  author: '',
  items: []
};
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
import fetch from 'isomorphic-unfetch';
import SubscriberCount from '../components/Podcast/SubscriberCount';
import PodcastSettings from '../components/Podcast/PodcastSettings';
import LoadingSpinner from '../components/Common/Loading';
import { setIsTyping } from '../lib/fileUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TextArea from 'antd/lib/input/TextArea';
import { podcastTypesExtra } from '../lib/genres';
import AppShareModal from '../components/Common/AppShareModal';
import AppButton from '../components/Common/AppButton';
import AddToTag from '../components/Playlist/AddToTag';
import BookInProgress from '../components/Podcast/BookInProgress';
import VideoThumbnail from '../components/Common/VideoThumbnail';
import ShowAppsFooter from '../components/Common/ShowAppsFooter';
import ChapterImage from '../components/Common/ChapterImage';

let widowHeight;

const initialState = {
  fromSearch: false,
  hasMore: true, itunesData: {},
  searchValues: false, searching: false, searchTerm: '', filteredEpisodes: [],
  stickDiv: false,
  // episodePaginationMap: new Map(), currPage: '', 
  showPagination: true, boxShadow: '',
  mostRecentEpisode: '',
  isReversed: false, loadingReversed: false,
  loadingLatestEpisodes: true
};

class podcast extends React.Component {
  static async getInitialProps(context) {
    // const feedUrl = context.query.feed;
    const itunesIdOrig = context.query.PzID || context.query.id;
    let itunesId = itunesIdOrig;
    if (itunesIdOrig.length < 5) {
      console.log('in short fetch');
      itunesId = await getPodcastIdFromShortLink(itunesIdOrig);
      console.log(itunesId);
    }
    // const genresString = context.query.genres;
    // console.dir(context.query);
    // console.dir(feedUrl);
    // console.dir(itunesId);
    // console.dir(genresString);
    if (itunesId) {
      let isItBrowser = process.browser;
      let podcastInfoGeneric;
      if (process.browser) {
        // isItBrowser = true;
        /// get podcastInfoGeneric from redux
        podcastInfoGeneric = getCurrentPodcastData(itunesId);
      }
      const now = Date.now();
      let allPromises = [];
      const latestEpisodesPromise = convertRSSToJsonLatestFirestore(itunesId).catch(err => null);
      allPromises.push(latestEpisodesPromise);
      let podcastInfoGenericPromise;
      if (!process.browser || !podcastInfoGeneric) {
        // isItBrowser = false;
        /// get podcastInfoGeneric from firestore

        podcastInfoGenericPromise = getPodcastDataDB(itunesId).catch(err => null)
        allPromises.push(podcastInfoGenericPromise);

        // try {
        //   const podcastFromDB = await getPodcastDataDB(itunesId);
        //   podcastInfoGeneric = podcastFromDB;
        // } catch (err) {
        //   try {
        //     /// get from itunes here if data doesn't exist
        //     podcastInfoGeneric = await getItunesDataServerByCollectionId(itunesId);
        //     logPodcastWithItunesData(podcastInfoGeneric);
        //   } catch (err) {
        //     return { podcastEpisodes: {} };
        //   }
        // }
      }

      const results = await Promise.all(allPromises);
      const json = results[0];
      if (results.length > 1) {
        podcastInfoGeneric = results[1];
        // console.dir(podcastInfoGeneric);
        // if (!podcastInfoGeneric) {
        //   try {
        //     /// get from itunes here if data doesn't exist
        //     podcastInfoGeneric = await getItunesDataServerByCollectionId(itunesId);
        //     logPodcastWithItunesData(podcastInfoGeneric);
        //   } catch (err) {
        //     return { podcastEpisodes: {} };
        //   }
        // }
      }

      const now2 = Date.now();
      console.log(now2 - now);
      console.dir(itunesId);
      // let genresArray = genresString.split(',');
      try {
        console.log(json);
        let feedUrl = podcastInfoGeneric.feedUrl;
        let genresArray = podcastInfoGeneric.genres;

        console.dir('pass');
        // console.dir(podcastInfoGeneric.statusT);
        // console.dir(podcastInfoGeneric.statusT == 0.25);
        // console.dir(json.items.length > 0 || podcastInfoGeneric.statusT == 0.25);
        // console.dir(json.feed);
        // console.dir(json.items);
        // console.dir('pass2');
        // console.dir((json.items && json.items.length > 0) || podcastInfoGeneric.statusT == 0.25);
        // console.dir((json.feed && ((json.items && json.items.length > 0) || podcastInfoGeneric.statusT == 0.25)));
        // const response = await fetch(convertRSSToJsonLatest(feedUrl, itunesId, -1, genresArray));
        // const json = await response.json();
        // const json = await convertRSSToJsonLatestFirestore(itunesId);
        // console.dir(json);
        // if (response.ok == true) {
        if (json.feed && ((json.items && json.items.length > 0) || podcastInfoGeneric.statusT >= 0.25)) {
          // const totalItemCount = json && json.feed && json.feed.totalItemCount || 0;
          const jsonItems = json && json.items; // giveNumberToEpisodes(json && json.items, 'latest', totalItemCount);
          let podcastEpisodes = { ...json, items: jsonItems };
          console.log('podcastInfoGeneric0');
          // const { episodePaginationMap, currPage } = setEpisodePagination(podcastEpisodes);
          console.log('podcastInfoGeneric');
          console.log(podcastInfoGeneric);
          return {
            podcastEpisodes, episodePaginationMap: {}, currPage: '',
            itunesId: parseInt(itunesId), feedUrl, genresArray, podcastInfoGeneric, isItBrowser: isItBrowser
          };
        } else {
          return { podcastEpisodes: {}, feedUrl, itunesId: parseInt(itunesId) };
        }
      } catch (err) {
        return { podcastEpisodes: {}, itunesId: parseInt(itunesId) };
      }

    } else {
      return { podcastEpisodes: {} };
    }
  }

  constructor(props) {
    super(props);
    // console.dir(props);
    this.state = {
      rawTokenCount: {},
      podcastEpisodes: props.podcastEpisodes,
      episodePaginationMap: props.episodePaginationMap,
      filterApplied: false,
      currPageEpisodeListType: 'all',
      loadingUnplayed: false,
      filteredRecentEpisodes: [],
      allEpisodes: [],
      settingsVisible: false,
      currPage: props.currPage || '',
      shareVisible: false,
      savingChapImages: false,
      ...initialState
    };
    console.dir('in state');
    console.dir(this.props.episodePaginationMap);
    //  {
    //   podcastEpisodes: {}, fromSearch: false,
    //   hasMore: true, itunesData: {},
    //   searchValues: false, searching: false, searchTerm: '', filteredEpisodes: [],
    //   stickDiv: false, episodePaginationMap: new Map(), currPage: '', showPagination: true, boxShadow: ''
    // };
    // this.props.loadingUserDetailsState(true);
    this.handleScroll = throttle(this.handleScroll, 200);
  }

  componentDidMount() {
    widowHeight = window.innerHeight;
    // for testing to see all have guid
    if (this.state.podcastEpisodes && this.state.podcastEpisodes.feed && this.state.podcastEpisodes.items) {
      for (let episodeInfo of this.state.podcastEpisodes.items) {
        if (!episodeInfo.guid || (episodeInfo.guid + '').length < 3) {
          console.error('guid not found for this episode.');
        }
      }
    }
    this.checkSearchBool();
    const { userDetails, podcastEpisodes, isItBrowser, podcastInfoGeneric } = this.props;
    console.dir(podcastEpisodes);
    // const totalItemCount = podcastEpisodes && podcastEpisodes.feed && podcastEpisodes.feed.totalItemCount || 0;
    // const jsonItems = giveNumberToEpisodes(podcastEpisodes && podcastEpisodes.items, 'latest', totalItemCount);
    // this.setState({ podcastEpisodes: podcastEpisodes });
    this.getItunesData(this.props.itunesId);
    logPodcastSeriesClick(this.props.itunesId);
    if (isItBrowser) {
      this.props.getPodcastData(this.props.itunesId);
    } else {
      this.props.fetchRelatedPodcasts(podcastInfoGeneric);
    }
    this._loadLatestEpisodes();
    this._loadMostRecentEpisode();
    // this.setEpisodePagination(this.props.podcastEpisodes);

    if (userDetails && userDetails.uid) {
      const currPageEpisodeListType = retrieveLocally(`currPageEpisodeListType_${this.props.itunesId}`) || 'all';
      if (currPageEpisodeListType !== 'all') {
        this.onEpisodeListTypeChange(currPageEpisodeListType);
      }
    }

    getTokenRawCount(this.props.itunesId).then(rawTokenCount => {
      console.dir(rawTokenCount);
      this.setState({ rawTokenCount });
    })
  }

  componentDidUpdate(prevProps) {
    // console.dir(prevProps.podcastEpisodes);
    // console.dir(this.props.podcastEpisodes);
    const { podcastEpisodes, isItBrowser, podcastInfoGeneric, userDetails } = this.props;
    console.dir(podcastInfoGeneric);
    if (podcastEpisodes !== prevProps.podcastEpisodes) {
      // this.setState({ podcastEpisodes: {} });
      // console.dir(this.props.podcastEpisodes);
      this.setState(initialState);
      // this.setState({
      //   fromSearch: false, hasMore: true, itunesData: {},
      //   searchValues: false, searching: false, searchTerm: '', filteredEpisodes: [],
      //   stickDiv: false, episodePaginationMap: new Map(), currPage: '', showPagination: true, boxShadow: ''
      // });
      this.checkSearchBool();
      // console.dir(podcastEpisodes);
      // const totalItemCount = podcastEpisodes && podcastEpisodes.feed && podcastEpisodes.feed.totalItemCount || 0;
      // const jsonItems = giveNumberToEpisodes(podcastEpisodes.items, 'latest', totalItemCount);
      // this.setState({ podcastEpisodes: podcastEpisodes });
      // console.dir(this.state.podcastEpisodes);
      // this.setState({ podcastEpisodes: this.props.podcastEpisodes });
      // this.setEpisodePagination(this.props.podcastEpisodes);
    }
    if (this.props.itunesId !== prevProps.itunesId) {
      logPodcastSeriesClick(this.props.itunesId);
      this.getItunesData(this.props.itunesId);
      if (isItBrowser) {
        this.props.getPodcastData(this.props.itunesId);
      } else {
        this.props.fetchRelatedPodcasts(podcastInfoGeneric);
      }
      this._loadLatestEpisodes();
      this._loadMostRecentEpisode();
    }
    if (this.props.userDetails !== prevProps.userDetails) {
      if (userDetails && userDetails.uid) {
        const currPageEpisodeListType = retrieveLocally(`currPageEpisodeListType_${this.props.itunesId}`) || 'all';
        if (currPageEpisodeListType !== 'all') {
          this.onEpisodeListTypeChange(currPageEpisodeListType);
        }
      }
    }
  }

  async _loadLatestEpisodes() {
    const { feedUrl, itunesId, genresArray } = this.props;
    const { podcastEpisodes } = this.state;
    const currentLatestEpisodeGuid = podcastEpisodes && podcastEpisodes.items && podcastEpisodes.items[0] && podcastEpisodes.items[0].guid;
    // const response = await fetch(convertRSSToJsonLatest(feedUrl, itunesId, -1, genresArray));
    // const json = await response.json();
    // console.dir(json);
    // // if (response.ok == true) {
    // if (json.feed && json.items && json.items.length > 0) {
    //   // const totalItemCount = json && json.feed && json.feed.totalItemCount || 0;
    //   const jsonItems = json && json.items; // giveNumberToEpisodes(json && json.items, 'latest', totalItemCount);
    //   if (jsonItems && jsonItems[0] && jsonItems[0].guid == currentLatestEpisodeGuid) {
    //     this.setState({ loadingLatestEpisodes: false });
    //   } else {
    //     let podcastEpisodes = { ...json, items: jsonItems };
    //     const { episodePaginationMap, currPage } = setEpisodePagination(podcastEpisodes);
    //     console.dir(podcastEpisodes);

    //     this.setState({
    //       podcastEpisodes, episodePaginationMap: episodePaginationMap, currPage, loadingLatestEpisodes: false
    //     });
    //   }
    // } else {
    //   if (itunesId > 0) {
    //     this.setState({ podcastEpisodes: {}, loadingLatestEpisodes: false });
    //   } else {
    //     this.setState({ loadingLatestEpisodes: false });
    //   }
    // }
  }

  checkSearchBool() {
    const { feedUrl } = this.props;

    if (isLocalStoragePresent() && localStorage.getItem('lastSearchBool') !== null) {
      const searchBool = JSON.parse(localStorage.getItem('lastSearchBool'));
      if (searchBool.feedUrl === feedUrl) {
        const now = new Date().getTime();
        console.dir(searchBool.time);
        const timeDiffSecs = (now - searchBool.time) / 1000;
        console.dir(timeDiffSecs);
        const fromSearch = timeDiffSecs < 15;
        console.dir(fromSearch);
        this.setState({ fromSearch });
      } else {
        this.setState({ fromSearch: false });
      }
    } else {
      this.setState({ fromSearch: false });
    }
  }

  // fetchNextEpisodesData = async () => {
  //   const { currPage } = this.state;
  //   const { episodePaginationMap } = this.state;
  //   // const totalItemCount = podcastEpisodes && podcastEpisodes.feed && podcastEpisodes.feed.totalItemCount || 0;
  //   // const episodesDownloadedSoFar = podcastEpisodes.items.length;
  //   // const episodeFrom = totalItemCount - episodesDownloadedSoFar;  // instead of episodesDownloadedSoFar, use last episode number
  //   const episodePaginationArray = Array.from(Object.keys(episodePaginationMap)); // [...episodePaginationMap.keys()];
  //   const currPageIndex = episodePaginationArray.indexOf(currPage) || 0;
  //   const nextPageKey = currPageIndex < episodePaginationArray.length - 1 ? episodePaginationArray[currPageIndex + 1] : ''; // check if array element exists
  //   if (nextPageKey) {
  //     // const episodeFrom = episodePaginationMap.get(nextPageKey)['start'];
  //     const episodeFrom = episodePaginationMap[nextPageKey]['start'];
  //     await this.fetchEpisodesData(episodeFrom);
  //     const hasMore = episodeFrom == episodesPerFetch ? false : true;
  //     this.setState({ hasMore, currPage: nextPageKey });
  //   } else {
  //     this.setState({ hasMore: false });
  //   }
  //   // console.dir(this.state.podcastEpisodes);
  // }

  fetchEpisodesData = async (episodeFrom, erasePrevEpisodes = false) => {
    if (erasePrevEpisodes) {
      this.setState({ loadingNewItems: true });
    }
    const { podcastEpisodes } = this.state;

    const { feedUrl, itunesId, genresArray } = this.props;
    // let genresArray = genresString.split(',');

    let response;
    if (episodeFrom == 'latest') {
      response = await fetch(convertRSSToJsonMore(feedUrl, itunesId, episodeFrom, -1, genresArray));
    } else {
      response = await fetch(convertRSSToJsonMore(feedUrl, itunesId, episodeFrom, episodesPerFetch, genresArray));
    }
    const json = await response.json();
    // console.dir(json);
    const totalItemCount = podcastEpisodes && podcastEpisodes.feed && podcastEpisodes.feed.totalItemCount || json.feed.totalItemCount || 0;
    // let episodeFirstNum = episodeFrom == 'latest' ? totalItemCount : episodeFrom;
    // for (let episode of json.items) {
    //   episode['appEpisodeNumber'] = episodeFirstNum;
    //   episodeFirstNum--;
    // }
    const jsonItems = json.items; // giveNumberToEpisodes(json.items, episodeFrom, totalItemCount);
    let currEpisodes = this.state.podcastEpisodes.items || [];
    let newEpisodeItems;
    if (erasePrevEpisodes) {
      newEpisodeItems = [...jsonItems];
    } else {
      newEpisodeItems = currEpisodes.concat(...jsonItems);
    }
    if (episodeFrom == 'latest' && totalItemCount > episodesPerFetch) {
      this.setState({ hasMore: true });
    } else if (episodeFrom != 'latest' && episodeFrom != episodesPerFetch && episodeFrom < totalItemCount) {
      this.setState({ hasMore: true });
    }
    this.setState({ podcastEpisodes: Object.assign({}, podcastEpisodes, { items: newEpisodeItems }), loadingNewItems: false });
  }

  // onPaginationChange = (page) => {
  //   window.scrollTo(0, 0);
  //   const { episodePaginationMap } = this.state;
  //   const episodeFrom = episodePaginationMap[page]['start'];
  //   this.setState({ currPage: page }, () => this.fetchEpisodesData(episodeFrom, true));
  // }

  handleScroll = () => {
    // let widowHeight = window.innerHeight;
    console.log(widowHeight);
    let scrollTop = window.scrollY; // event.srcElement.body.scrollTop;
    if (scrollTop > widowHeight * 4.5 / 100) { // 4.5vw is the height of top bar
      this.setState({ stickDiv: true });
    } else {
      this.setState({ stickDiv: false });
    }
  }

  getItunesData(itunesId) {
    // getItunesDataByCollectionId(itunesId).then((data) => {
    //   // console.dir(data);
    //   this.setState({ itunesData: data });
    //   // this.props.getPopularEpisodesInSeries(data);
    //   this.props.fetchRelatedProducts(data['collectionId'], data);
    // })
  }

  handleSearch = async (searchTerm) => {
    if (!searchTerm) {
      return;
    }
    logViewSearchResults(searchTerm, 'searchInSeries');
    this.setState({ searching: true, searchTerm, showPagination: false })
    // const { feedUrl, itunesId } = this.props;
    const { itunesData } = this.state;

    const { podcastInfoGeneric } = this.props;
    const itunesDataFin = itunesData.collectionId ? itunesData : podcastInfoGeneric;
    // let escapedGenres = encodeURIComponent(itunesData.genres && itunesData.genres.join(','));
    // const escapedUrl = encodeURIComponent(feedUrl);
    try {
      const { userDetails } = this.props;
      const limitNumberOfResults = (userDetails && userDetails['uid']) ? 500 : 3;
      // const response = await tokenFetch(`${cdnApi}searchSeries?searchTerm=${searchTerm}&feedUrl=${escapedUrl}&collectionId=${itunesId}&genres=${escapedGenres}`);
      // const json = await response.json();
      const filteredEpisodes = await searchInSeries(searchTerm, itunesDataFin, limitNumberOfResults);
      // console.dir(json);
      this.setState({ filteredEpisodes: filteredEpisodes, searchValues: true, searching: false });
    } catch (err) {
      console.error(err);
      this.setState({ filteredEpisodes: [], searchValues: true, searching: false });
    }
  }

  clearSearch = () => {
    this.setState({ filteredEpisodes: [], searchValues: false, searchTerm: '', showPagination: true });
  }

  changeSearchTerm = (event) => {
    setIsTyping();
    // console.log(event.target.value);
    this.setState({ searchTerm: event.target.value })
  }

  changeAffixShadow = (affixed) => {
    if (affixed) {
      this.setState({ boxShadow: 'box-shadow' });
    } else {
      this.setState({ boxShadow: '' });
    }
  }

  setAllEpisodesAsPlayedFn = (podcastData, played) => {
    const { userDetails } = this.props;
    if (!userDetails || !userDetails.uid) {
      message.warning('Please sign in to mark episodes as played/unplayed!');
      return;
    }
    const { itunesData } = this.state;
    notification.info({
      // duration: 0,
      message: 'Marking episodes',
      description:
        `All the episodes of this podcast will be marked as ${played ? 'played' : 'unplayed'} soon.`,
      onClick: () => {
        console.log('Notification Clicked!');
      },
    });
    this.props.setAllEpisodesAsPlayed(itunesData, played);
  }



  _loadMostRecentEpisode = async () => {
    try {
      const { itunesId, loadMostRecentEpisodeInSeries } = this.props;
      const mostRecentEpisode = await loadMostRecentEpisodeInSeries(itunesId);
      console.dir(mostRecentEpisode);
      if (mostRecentEpisode) {
        // print('mostRecentEpisode: ' + mostRecentEpisode.title);
        this.setState({ mostRecentEpisode });
      }
    } catch (err) { console.dir(err); }
  }

  fetchAllUnplayed = async () => {
    this.setState({ loadingUnplayed: true });
    // final itunesData = widget.itunesData;
    const { itunesData } = this.state;
    const { podcastInfoGeneric } = this.props;
    const itunesDataFin = itunesData.collectionId ? itunesData : podcastInfoGeneric;
    console.dir(itunesDataFin);
    // const feedUrl =
    //   'feedUrl' in itunesDataFin ? itunesDataFin['feedUrl'] : '';
    // const genresArray = 'genres' in itunesDataFin
    //   ? itunesDataFin['genres']
    //   : [];
    console.dir(itunesDataFin);
    try {
      const allEpisodesLoc = await getAllEpisodesInSeries(itunesDataFin);
      // .then((allEpisodesLoc) => {
      // if(!mounted) {
      //   return;
      // }
      console.dir(allEpisodesLoc);
      this.setState({
        allEpisodes: allEpisodesLoc,
        loadingUnplayed: false
      });
    } catch (err) {
      this.setState({
        allEpisodes: [],
        loadingUnplayed: false
      });
    }
  }


  showFilteredFavourites = memoizeOne((allEpisodes, personalRatingsValues) => {
    console.dir(allEpisodes);
    console.dir(personalRatingsValues);
    // const { userDetails, reviewsState } = this.props;
    const filteredEpisodes = [];
    for (const episode of (allEpisodes || [])) {
      const guidCleaned = cleanGUID(episode);
      if (personalRatingsValues[guidCleaned] && personalRatingsValues[guidCleaned].rating >= 3) {
        filteredEpisodes.push(episode);
      }
    }
    filteredEpisodes.sort((ep1, ep2) => {
      const guidCleaned1 = cleanGUID(ep1);
      const guidCleaned2 = cleanGUID(ep2);
      return personalRatingsValues[guidCleaned2].rating - personalRatingsValues[guidCleaned1].rating;
    });
    console.dir(filteredEpisodes);
    return filteredEpisodes;
  });

  getExplicitUnplayedEpisodes = memoizeOne((episodesToCheck,
    personalMarkPlayedValues) => {
    let unplayedEpisodes = [];
    unplayedEpisodes = episodesToCheck
      .filter((episode) => !isEpisodeExplicitlyMarkedPlayed(
        episode.guid, personalMarkPlayedValues));
    // .toList();
    return unplayedEpisodes;
  });

  onEpisodeListTypeChange = async (currPageEpisodeListType) => {
    const { itunesData } = this.state;
    const { userDetails } = this.props;
    if (!userDetails || !userDetails.uid) {
      message.warning('Please sign in to filter episodes.');
      return;
    }
    if (currPageEpisodeListType == 'all') {
      // filterApplied = false;
      this.setState({ filterApplied: false });
      saveLocally(`currPageEpisodeListType_${this.props.itunesId}`, 'all', 24 * 3650);
    } else if (currPageEpisodeListType == 'unplayed') {
      // filterApplied = true;
      this.fetchAllUnplayed();
      this.setState({ filterApplied: true });
      saveLocally(`currPageEpisodeListType_${this.props.itunesId}`, 'unplayed', 24 * 3650);
      // } else if (currPageEpisodeListType == 'downloaded') {
    } else if (currPageEpisodeListType == 'favourites') {
      this.fetchAllUnplayed();
      // filterApplied = true;
      this.setState({ filterApplied: true });
    } else if (currPageEpisodeListType == 'popular') {
      // this.fetchAllUnplayed();
      // filterApplied = true;
      this.setState({ filterApplied: true });
    } else if (currPageEpisodeListType == 'recent') {
      // filterApplied = true;
      this.setState({ filterApplied: true });
      const filteredRecentEpisodes = await this.props.getRecentEpisodesInSeries(itunesData.collectionId);
      if (filteredRecentEpisodes) {
        this.setState({
          filteredRecentEpisodes,
        });
      }
    }
    this.setState({ currPageEpisodeListType });
  }

  showPodcastSettings = () => {
    const { userDetails } = this.props;
    if (!userDetails || !userDetails.uid) {
      message.warning('Please sign in to edit podcast settings.');
      return;
    }
    this.setState({ settingsVisible: true });
  }
  handleClose = () => {
    this.setState({ settingsVisible: false });
  }

  toggleReverse = async () => {
    const { isReversed } = this.state;
    const newReversed = !isReversed;
    this.setState({ isReversed: newReversed });
    if (newReversed) {
      this.setState({ loadingReversed: true });
      await this.fetchAllUnplayed();
      this.setState({ loadingReversed: false });
    }
    console.dir(isReversed);

    //// Code to reverse Auto Queue episodes
    const podcastEpisodesObj = this.state.podcastEpisodes || {};
    const podcastEpisodes = podcastEpisodesObj.items || [];
    const audioInformation = this.props.audioInfo || {};
    if (audioInformation.guid) {
      const indexPresent = podcastEpisodes.findIndex((ep) => ep.guid == audioInformation.guid);
      if (indexPresent > -1) {
        const podcastEpisodesLoc = newReversed ? podcastEpisodes.slice().reverse() : podcastEpisodes;
        const currEpisodeIndex = podcastEpisodesLoc.findIndex((el) => el.guid == audioInformation.guid);
        if (currEpisodeIndex >= 0 && currEpisodeIndex < podcastEpisodesLoc.length - 1) {
          const nextEpisodesList = podcastEpisodesLoc.slice(currEpisodeIndex + 1);
          this.props.addToAutoQueueInfoFn(nextEpisodesList, '');
        }
      }
    }
  }
  markBookCheckedFn = (type = 1, status = 2) => {
    if (window.confirm("Are you sure?")) {
      const { itunesId } = this.props;
      markBookChecked(itunesId, type, status).then(data => {
        console.dir(data);
        const errorMessageArr = data['errorMessages'] || [];
        console.dir(errorMessageArr);
        if (errorMessageArr.length > 0) {
          let errMessage = '';
          console.dir(errMessage);
          errorMessageArr.forEach(el => {
            errMessage += el + '\n';
          })
          console.dir(errMessage);
          notification.info({
            message: <div>Saved but Length Issue<br />
              {errMessage}
            </div>,
            // description: 'Voice Generated for ' + request.collectionName + ` (${request.collectionId})`,
            duration: null
          });
        } else {
          message.success('Updated');
        }
      }).catch(err => {
        alert('There was an error saving. Contact suboo');
      })
      return;
    }
  }

  changeDesc = (e) => {
    const { podcastEpisodes } = this.state;
    this.setState({ podcastEpisodes: { ...podcastEpisodes, feed: { ...podcastEpisodes.feed, description: e.target.value } } });
  }
  changeTitle = (e) => {
    const { podcastEpisodes } = this.state;
    this.setState({ podcastEpisodes: { ...podcastEpisodes, feed: { ...podcastEpisodes.feed, title: e.target.value } } });
  }
  saveDesc = () => {
    if (window.confirm("Are you sure?")) {
      const { itunesId } = this.props;
      const { podcastEpisodes } = this.state;
      editBookDescription(itunesId, podcastEpisodes.feed.description).then(() => {
        message.success('Description updated');
      });
    }
  }
  saveTitle = () => {
    if (window.confirm("Are you sure?")) {
      const { itunesId } = this.props;
      const { podcastEpisodes } = this.state;
      editBookDescription(itunesId, '', podcastEpisodes.feed.title);
    }
  }
  showShareModal = () => {
    this.setState({
      shareVisible: true,
    });
  };
  handleShareCancel = () => {
    this.setState({
      shareVisible: false,
    });
  }

  getMainDescription = (desc = '') => {
    const { podcastInfoGeneric } = this.props;
    console.dir(podcastInfoGeneric);
    if (isMagazine(podcastInfoGeneric)) {
      return [
        `Short on time for a full book? Explore these key ideas on ${podcastInfoGeneric['collectionName'] ?? ''}. `,
        'Each keyidea is independent, allowing you to explore any topic that catches your interest. ',
        'These insights are gathered from top trending magazines worldwide.'
      ];
    } else if (isNews(podcastInfoGeneric)) {
      return ['Latest News from around the world.'];
    } else {
      // return desc;
      return desc.trim()
        .split('?')
        .map((el) => el.trim());
    }
  }

  markChapterFirstImageDoneFn = () => {
    const { itunesId, podcastEpisodes } = this.props;
    const eps = podcastEpisodes?.items ?? [];
    if (eps.length < 1) {
      return;
    }
    let textToCopy = itunesId + '\n\n';
    textToCopy += eps[0].description.replaceAll('\n', '') + '\n\n\n\n';
    textToCopy += eps[eps.length - 1].description.replaceAll('\n', '') + '\n\n';
    navigator.clipboard.writeText(textToCopy);

    this.setState({ savingChapImages: true });
    markChapterImagesDone(this.props.itunesId, true).then(data => {
      console.dir(data);
      // this.setState({ rawTokenCount });
      this.setState({ savingChapImages: false });
      message.success('First Chapter Image marked done');
      location.reload();
    }).catch(err => {
      this.setState({ savingChapImages: false });
      message.error('Chapter Images error');
    })
  }
  markChapterImagesDoneFn = () => {
    this.setState({ savingChapImages: true });
    markChapterImagesDone(this.props.itunesId).then(data => {
      console.dir(data);
      // this.setState({ rawTokenCount });
      this.setState({ savingChapImages: false });
      message.success('Chapter Images marked done');
      location.reload();
    }).catch(err => {
      this.setState({ savingChapImages: false });
      message.error('Chapter Images error');
    })
  }

  render() {
    const { userDetails, itunesId, isItBrowser, podcastInfoGeneric, dbPodcastState,
      personalRatingsValues, personalMarkPlayedValues, allPopularEpisodesData, settingsState } = this.props;
    const { loadingUserDetails } = this.props.loadingState;
    const { borderColor, mainLayoutColor, topBar } = this.props.settingsState;
    // const { userDetails } = this.props;
    const { hasMore, fromSearch, searchValues, searching, searchTerm, filteredEpisodes, itunesData, currPage, loadingNewItems,
      showPagination, boxShadow, filterApplied, currPageEpisodeListType, allEpisodes, filteredRecentEpisodes, mostRecentEpisode,
      settingsVisible, isReversed, loadingReversed, loadingLatestEpisodes, episodePaginationMap, rawTokenCount,
      shareVisible, savingChapImages } = this.state;
    const podcastEpisodes = this.state.podcastEpisodes;
    // const podcastEpisodes = (this.state.podcastEpisodes && this.state.podcastEpisodes.feed && this.props.podcastEpisodes.feed &&
    //   this.state.podcastEpisodes.feed == this.props.podcastEpisodes.feed) ? this.state.podcastEpisodes : this.props.podcastEpisodes; // for serverside render before setting state.
    // console.dir(podcastEpisodes);
    // console.log(JSON.parse(JSON.stringify(podcastEpisodes)))
    // if (process.browser) {
    //   setBackButtonCache(itunesId, { podcastEpisodes, episodePaginationMap, currPage });
    // }
    // console.dir(podcastInfoGeneric);
    // console.dir(dbPodcastState);
    console.dir(podcastEpisodes);
    const isUserAdmin = isAdmin(userDetails);
    if (!podcastEpisodes) {
      return <InvalidPodcast message="Sorry we couldn't find the podcast. Please try again or search for a similar podcast." />; // (<p>Invalid podcast. Please try another one.</p>);
    }
    let podcastInfo = podcastEpisodes && podcastEpisodes.feed || defaultVal;
    if (itunesData && typeof itunesData.artworkUrl600 !== 'undefined' && itunesData.collectionId === itunesId) {
      podcastInfo['artworkUrl600'] = itunesData.artworkUrl600;
    }

    // const podcastTitle = podcastInfo.title || (dbPodcastState[String(itunesId)] && dbPodcastState[String(itunesId)].collectionName) || (podcastInfoGeneric?.collectionName || '');
    const podcastTitle = podcastInfoGeneric?.collectionName || itunesData.collectionName; // || (dbPodcastState[String(itunesId)] && dbPodcastState[String(itunesId)].collectionName) || (podcastInfoGeneric?.collectionName || '');

    /// if isItBrowser, get from client side, in <SubscribeOption>
    const subscribersFromParent = isItBrowser ? null : (podcastInfoGeneric?.subscribers || 0);
    // console.log('podcastInfo artworkUrl600 : ' + podcastInfo['artworkUrl600']);
    // console.dir(itunesData);
    // console.dir(podcastInfo);
    // const podcastShareUrl = `https://tedapp.ai/podcast/${convertToSlug(podcastTitle || '')}?feed=${feedUrl}&PzID=${itunesId}&genres=${genresString}`;
    // console.dir(podcastInfo);
    const podcastShareUrl = `https://tedapp.ai` + podcastSlugUrl(podcastTitle, itunesId);
    let podcastInfoLink = '';
    if (podcastInfo.link && typeof podcastInfo.link === 'string') {
      podcastInfoLink = podcastInfo.link.startsWith('http') ? podcastInfo.link : 'https://' + podcastInfo.link;
    } else if (podcastInfo.link && typeof podcastInfo.link === 'object') {
      podcastInfoLink = podcastInfo.link.href || '';
    }

    // console.dir(allPopularEpisodesData);
    const popularEpisodesMap = allPopularEpisodesData[itunesId] || {};
    // console.dir(popularEpisodesMap);
    // console.dir(allEpisodes);

    let filteredNeededEpisodes = podcastEpisodes?.items ?? [];

    // if (currPageEpisodeListType === 'unplayed') {
    //   // filteredNeededEpisodes = this.showFilteredFavourites(allEpisodes, personalRatingsValues) || [];
    //   let episodesToCheck = (allEpisodes && allEpisodes.length > 0) ? allEpisodes : podcastEpisodes['items'];
    //   console.dir(episodesToCheck);
    //   const unplayedEpisodesOrg =
    //     this.getExplicitUnplayedEpisodes(
    //       episodesToCheck, personalMarkPlayedValues);
    //   filteredNeededEpisodes = unplayedEpisodesOrg;
    //   console.dir(unplayedEpisodesOrg);
    //   // sortedEpisodes(unplayedEpisodesOrg, episodeOrderSort);
    //   if (isReversed) {
    //     filteredNeededEpisodes = filteredNeededEpisodes.slice().reverse();
    //   }
    // } else if (currPageEpisodeListType === 'favourites') {
    //   filteredNeededEpisodes = this.showFilteredFavourites(allEpisodes, personalRatingsValues) || [];
    // } else if (currPageEpisodeListType === 'popular') {
    //   filteredNeededEpisodes = Object.values(popularEpisodesMap);
    // } else if (currPageEpisodeListType === 'recent') {
    //   filteredNeededEpisodes = filteredRecentEpisodes;
    // } else if (isReversed) {
    //   filteredNeededEpisodes = allEpisodes && allEpisodes.slice().reverse() || [];
    // }
    console.dir(filteredNeededEpisodes);
    console.dir(podcastInfoGeneric);

    const menu = (
      <Menu>
        <AddToTag podcast={podcastInfoGeneric} />
        {/* <Menu.Item key="markAllPlayed">
          <p className='mb-0' onClick={this.setAllEpisodesAsPlayedFn.bind(this, podcastInfo, true)}>Mark All as Played</p>
        </Menu.Item>
        <Menu.Item key="markAllUnPlayed">
          <p className='mb-0' onClick={this.setAllEpisodesAsPlayedFn.bind(this, podcastInfo, false)}>Mark All as Unplayed</p>
        </Menu.Item>
        <Menu.Item key="podcastSettings">
          <p className='mb-0' onClick={this.showPodcastSettings}>Settings</p>
        </Menu.Item> */}
      </Menu >
    );

    const bookProgressStageVal =
      bookProgressStage(podcastInfoGeneric);
    console.dir(bookProgressStageVal);
    let showSectionEpisodes =
      bookProgressStageVal > 10 && (podcastEpisodes?.items ?? []).length > 0;
    if (bookProgressStageVal == 10 && isUserAdmin) {
      showSectionEpisodes = true;
    }

    const descPoints = this.getMainDescription(podcastEpisodes?.feed?.description ?? '');

    let totalTime = 0;

    try {
      (podcastEpisodes?.items ?? []).forEach((element) => {
        // utils.printLog('duration');
        // utils.printLog(element.enclosure.duration);
        totalTime += element?.enclosure?.duration ?? 0;
      });
    } catch (err) {
      // utils.printLog('duration err');
      // utils.printLog(err);
    }


    // return (<div></div>)

    return (
      <div className='list'>
        <NextSeo
          title={`${podcastTitle || 'Book Title'} | Listen on Accelerated`}
          description={`${getDescription(podcastInfo)}`}
          noindex={itunesId < 0}
          nofollow={itunesId < 0}
          canonical={podcastShareUrl}
          openGraph={{
            title: `${podcastTitle || 'Podcast Title'}`,
            description: `${getDescription(podcastInfo)}`,
            images: [{
              url: podcastInfo['artworkUrl600'] || (podcastInfo && podcastInfo.image),
              alt: `Image of ${podcastTitle || ''} podcast`,
              width: 600,
              height: 600,
            }],
            type: 'website',
            locale: 'en_IE',
            url: podcastShareUrl,
            site_name: 'Accelerated'
          }}
          twitter={{
            handle: '@tedapp',
            site: '@tedapp',
            cardType: 'summary',
          }}
        />

        {
          settingsVisible && <Modal
            bodyStyle={{ minHeight: '240px' }}
            title={<h5>Show Settings</h5>}
            visible={settingsVisible}
            onCancel={this.handleClose}
            footer={null}
          >
            <PodcastSettings collectionId={`${itunesId}`}
              callbackParent={this.handleClose} />
          </Modal>
        }

        {fromSearch &&
          <Breadcrumb style={{ marginBottom: `${spacing()}` }} separator=">">
            <Breadcrumb.Item><a onClick={() => Router.back()}>Search</a> </Breadcrumb.Item>
            <Breadcrumb.Item> {podcastTitle || 'Invalid'}</Breadcrumb.Item>
          </Breadcrumb>}
        {podcastEpisodes && podcastEpisodes.feed ?
          <div className='main-page'>
            <header>
              <Row style={{}}>
                <Col xs={24} md={6} xl={4} style={{ paddingBottom: `${spacing()}` }}>
                  {/* <img className='main-img' src={podcastInfo && podcastInfo.image} /> */}
                  <div className='main-img-wrapper'>
                    {/* <img key={podcastInfo.image} className='main-img' alt={`Image of ${podcastTitle || ''} podcast`}
                    src={getPodcastImgSize(podcastInfo['artworkUrl600'] || podcastInfo && podcastInfo.image, 'default')} /> */}
                    <img key={podcastInfo.image} className='main-img' alt={`${podcastTitle || ''} book`}
                      src={bookImage(podcastInfoGeneric)} />
                    <div className='news-icon'>
                      {isNews(podcastInfoGeneric) && stringToDateDay(podcastInfoGeneric.releaseDate)}
                    </div>
                    {/* <div className='main-img'> */}
                    {/* <Img className='main-img'
                    src={[getPodcastImgSize(podcastInfo['artworkUrl600'] || podcastInfo && podcastInfo.image, 'default')]}
                    loader={<div style={{ backgroundColor: `${rightSideBarColor}` }} className='load-image'></div>} /> */}
                    {/* </div> */}
                  </div>
                  {/* <div className='main-img'>
                  <Img
                    src={[getPodcastImgSize(podcastInfo['artworkUrl600'] || podcastInfo && podcastInfo.image, 'md')]}
                    loader={<div style={{ backgroundColor: `${rightSideBarColor}` }} className='load-image'></div>} />
                </div> */}
                  <br />
                  <Row style={{ alignItems: 'center' }}>
                    <Col xs={0} md={20}>
                      {/* <AppShare type='podcasts' data={podcastInfo} shareUrl={podcastShareUrl}
                        title={`Book Summary: ${cleanText(podcastTitle)}`} /> */}
                      <AppButton style={{ width: '100%' }} onClick={this.showShareModal}>Share</AppButton>
                      <AppShareModal visible={shareVisible} shareUrl={podcastShareUrl} title={`Book Summary: ${cleanText(podcastTitle)}`}
                        type='' data={podcastInfo}
                        handleCancelModal={this.handleShareCancel} />
                    </Col>
                    <Col xs={0} md={4} style={{ textAlign: 'right', marginTop: '3px' }}>
                      <Dropdown overlay={menu} trigger={['click']}>
                        <div className="ant-dropdown-link css-link">
                          <SettingOutlined style={{ fontSize: `${fixedSpacing('md')}` }} />
                        </div>
                      </Dropdown>
                    </Col>
                  </Row>
                  {/* <div style={{ marginTop: `${spacing('')}` }}>
                    <a href={`https://podfollow.com/${itunesId}/view`} target="_blank"
                      rel="noopener noreferrer nofollow">
                      <Button style={{ width: '100%' }}>
                        <img style={{ maxWidth: '100%', width: '20px' }} src={`${staticAssetsPrefix}/static/images/podfollow.png`} />
                        podfollow
                        &nbsp;<FontAwesomeIcon className='' icon={['fas', 'share-square']} style={{ fontSize: '12px' }} />
                      </Button>
                    </a>
                  </div> */}
                  {/* <div style={{ marginTop: `${spacing('')}` }}>
                    <AppShare type='podcasts' data={podcastInfo} shareUrl={podcastShareUrl} title={`Book Summary: ${cleanText(podcastTitle)}`} />
                  </div> */}
                </Col>
                <Col xs={24} md={17} xl={19} offset={1} style={{ paddingRight: '1em' }}>
                  <div className='' style={{ display: 'flex', }}>

                    <div style={{ flex: 1 }}>
                      {!isUserAdmin ?
                        <h1 className='title'>{podcastInfoGeneric && cleanText(podcastTitle)}</h1>
                        : <>
                          <TextArea rows={1} onChange={this.changeTitle} value={podcastEpisodes.feed.title} />
                          <Button type='primary' onClick={this.saveTitle}>Save Title</Button>
                        </>}

                      {podcastInfoGeneric.artistName && <div style={{ marginTop: '0.5em', marginBottom: '0.75em' }}>
                        <h3 style={{}}>
                          {cleanText(podcastInfoGeneric.artistName)} &nbsp;
                          {/* <span style={{ fontSize: `${spacing('sm')}`, position: 'absolute' }} ><FontAwesomeIcon icon='external-link-alt' size='sm' /></span> */}
                        </h3>
                      </div>}
                      {isUserAdmin && <p>{podcastInfoGeneric.rating} ({podcastInfoGeneric.ratedBy})</p>}
                      {isUserAdmin && <p>{podcastInfoGeneric.p}</p>}
                      <div style={{ display: 'flex', marginBottom: '8px', marginTop: '4px' }}>
                        <h4 style={{ marginRight: '24px' }}><FontAwesomeIcon icon={['fas', 'book-open']} style={{ marginLeft: '0px', fontSize: `16px`, opacity: 0.8 }} /> &nbsp;{podcastEpisodes?.items?.length ?? 0} Key ideas</h4>
                        <h4 style={{ marginRight: '24px' }}><FontAwesomeIcon icon={['far', 'clock']} style={{ marginLeft: '0px', fontSize: `16px` }} /> &nbsp;{secToTime(totalTime, true)}</h4>
                        {bookProgressStageVal > 30 &&
                          (podcastInfoGeneric['ratingA'] ?? 1) > 4 &&
                          (podcastInfoGeneric['ratedByA'] ?? 1) > 5 &&
                          <h4><FontAwesomeIcon icon={['far', 'star']} style={{ marginLeft: '0px', fontSize: `16px` }} /> &nbsp;{podcastInfoGeneric.ratingA} ({ratingDisplay(podcastInfoGeneric.ratedByA)})</h4>
                        }
                      </div>
                      <div style={{ marginBottom: `12px`, display: 'flex', flexWrap: 'wrap', }}>
                        {podcastInfoGeneric && podcastInfoGeneric.genres && podcastInfoGeneric.genres.map(genre => {
                          if (!genre.includes('odcast') && podcastTypesExtra()[genre]?.name) {
                            return <Tag key={genre} style={{ display: 'inline', cursor: 'auto', background: colors.brown }}
                            >{podcastTypesExtra()[genre]?.name} &nbsp;</Tag>
                          }
                        })}
                      </div>
                      {/* <br /> */}
                      <div className='only-desktop' >
                        {/* <div style={{ flex: 1 }}> */}
                        {/* <ExpandCollapse key={podcastEpisodes.feed} textInfo={podcastEpisodes && podcastEpisodes.feed && podcastEpisodes.feed.description
                    && podcastEpisodes.feed.description.replace(/<br>/g, '') || 'No Description'} parent='podcast' /> */}
                        {/* <p className='extra-line-height'>{podcastEpisodes && podcastEpisodes.feed && podcastEpisodes.feed.description
                      && podcastEpisodes.feed.description.replace(/<br>/g, '') || 'No Description'}</p> */}

                        {!isUserAdmin ? <h4 style={{ maxWidth: '800px' }} className='serif extra-line-height'>
                          <div>
                            {descPoints.map((descPoint, ind) => (
                              <div key={ind} style={{ display: descPoint ? 'flex' : 'none' }}>
                                <div>
                                  <FontAwesomeIcon style={{ marginRight: '6px', fontSize: `12px`, }} icon='bolt' />
                                </div>
                                <h4 className='serif extra-line-height'>{descPoint +
                                  ((isNews(podcastInfoGeneric) || isMagazine(podcastInfoGeneric))
                                    ? ''
                                    : (`${ind < descPoints.length - 1 ? '?' : ''}`))}</h4>
                              </div>
                            ))}
                          </div>
                          { }
                          {/* {podcastEpisodes.feed.description} */}
                        </h4> :
                          <div>
                            <TextArea rows={5} onChange={this.changeDesc} value={podcastEpisodes.feed.description} />
                            <Button type='primary' onClick={this.saveDesc}>Save Description</Button>
                          </div>}
                      </div>
                      {/* <br /> */}
                      {/* <p>{podcastEpisodes.feed.authorDesc}</p> */}
                    </div>
                    <div className='only-desktop' style={{ width: podcastInfoGeneric.aboutImage ? '400px' : 0 }}>
                      <ChapterImage collectionId={itunesId}
                        width={isUserAdmin ? '100%' : '100%'}
                        thumbnail={podcastInfoGeneric.aboutImage || ''} />
                    </div>
                    {/* </div> */}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={24} xl={0}>
                  {/* <ExpandCollapse key={podcastEpisodes.feed} textInfo={podcastEpisodes && podcastEpisodes.feed && podcastEpisodes.feed.description
                  && podcastEpisodes.feed.description.replace(/<br>/g, '') || 'No Description'} parent='podcast' /> */}
                  <p className='extra-line-height'>
                    {/* {podcastEpisodes && podcastEpisodes.feed && podcastEpisodes.feed.description
                    && podcastEpisodes.feed.description.replace(/<br>/g, '') || 'No Description'} */}
                    {/* {this.getMainDescription(podcastEpisodes?.feed?.description ?? '')}; */}
                    <div style={{ textAlign: 'center' }}>
                      <ChapterImage collectionId={itunesId}
                        // width={isUserAdmin ? '600px' : '300px'}
                        thumbnail={podcastInfoGeneric.aboutImage || ''} />
                    </div>
                    <div>
                      {descPoints.map((descPoint, ind) => (
                        <div key={ind} style={{ display: descPoint ? 'flex' : 'none' }}>
                          <div>
                            <FontAwesomeIcon style={{ marginRight: '6px', fontSize: `12px`, }} icon='bolt' />
                          </div>
                          <h4 className='serif extra-line-height'>{descPoint +
                            ((isNews(podcastInfoGeneric) || isMagazine(podcastInfoGeneric))
                              ? ''
                              : (`${ind < descPoints.length - 1 ? '?' : ''}`))}</h4>
                        </div>
                      ))}
                    </div>
                  </p>
                </Col>
              </Row>
            </header>
            {/* {!loadingUserDetails && !userDetails && <UnsignedInfo />} */}
            {isUserAdmin &&
              <div style={{ display: 'flex' }}>
                <Button type='primary' disabled={podcastInfoGeneric.statusT >= 2} onClick={this.markBookCheckedFn.bind(this, 1, 2)}>Text Checked</Button>
                <div style={{ width: '60px' }}>&nbsp;</div>
                <Button type='primary' disabled={podcastInfoGeneric.statusT == 1.5} onClick={this.markBookCheckedFn.bind(this, 1, 1.5)}>Text Checked (BETA)</Button>
                <div style={{ width: '60px' }}>&nbsp;</div>
                {podcastInfoGeneric.statusV && <Button type='primary' disabled={podcastInfoGeneric.statusV >= 2} onClick={this.markBookCheckedFn.bind(this, 2, 2)}>Voice Checked</Button>}
                {podcastInfoGeneric.statusV == 1 && <p>Voice generated. Test Now.</p>}
                <Button style={{ marginLeft: '1em' }} type='primary'
                  disabled={podcastInfoGeneric.statusT <= 1 || podcastInfoGeneric.chapImages || savingChapImages}
                  onClick={this.markChapterFirstImageDoneFn}>Copy Chapter Image</Button>
                {/* onClick={this.markChapterFirstImageDoneFn}>Chapter First Image Done</Button> */}
              </div>
            }
            <div style={{ height: '32px' }}>&nbsp;</div>
            {podcastInfoGeneric['video'] != null &&
              podcastInfoGeneric['video'] &&
              podcastInfoGeneric['videoUrl'] != null &&
              podcastInfoGeneric['videoThumb'] != null && <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '4em 4em',
                marginTop: '0'
              }}>
                <div>
                  <VideoThumbnail
                    userDetails={userDetails}
                    videoUrl={bookVideoFromRawId(podcastInfoGeneric['videoUrl'])}
                    thumbnailUrl={bookVideoThumbFromRaw(podcastInfoGeneric['videoThumb'])} />
                </div>
                <div style={{ marginLeft: '2em', width: '240px' }}>
                  <h2>Short Video Summary</h2>
                  <p>Use it for a quick preview or to refresh your memory after the full summary!</p>
                </div>
              </div>}
            <div className='only-mobile' style={{ marginBottom: '2em' }}>
              <ShowAppsFooter comment={''} />
            </div>
            <div>
              {/* {loadingUserDetails && <p>Loading&hellip;</p>} */}

              {/* <div style={{ height: '55px' }} className={`header ${!loadingLatestEpisodes ? 'header-visible' : ''}`}>
                <PodcastHeader episodePaginationMap={episodePaginationMap} callBackParent={this.onPaginationChange} currPage={currPage}
                  callBackParentFilter={this.onEpisodeListTypeChange} currPageEpisodeListType={currPageEpisodeListType}
                  toggleReverse={this.toggleReverse} showPagination={showPagination} isReversed={isReversed} />
              </div> */}
              <div>
                {!searching && searchValues == true && (!userDetails || !userDetails.uid) &&
                  <UnsignedInfo message='Please sign in for more and improved search results.' />}
                {/* {searching && <div><Spin indicator={antIcon} />&nbsp; Loading results&hellip;</div>} */}
                {searching && <EpisodeSkeleton />}
                {
                  !searching && searchValues == true ? typeof filteredEpisodes !== 'undefined' && filteredEpisodes.length > 0 ? filteredEpisodes.map((podcastEpisode) => (
                    <PodcastEpisode key={podcastEpisode.pubDate + podcastEpisode.title} podcastEpisode={podcastEpisode} parent='podcast'
                      popularEpisodesMap={popularEpisodesMap}
                      itunesData={podcastInfoGeneric}
                      itunesImage={itunesData && itunesData.artworkUrl600 || podcastInfo && podcastInfo.image || ''} podcastEpisodes={podcastEpisodes.items} />
                  )) : 'No matching results found. Please try again with a different term.' : ''
                }
              </div>

              {!showSectionEpisodes && <BookInProgress itunesData={podcastInfoGeneric} lottieWidth={400} />}

              {/* {mostRecentEpisode && !isEpisodeExplicitlyMarkedPlayed(mostRecentEpisode.guid, personalMarkPlayedValues) && <PodcastEpisode key={mostRecentEpisode.pubDate + mostRecentEpisode.title} podcastEpisode={mostRecentEpisode} parent='podcast'
                itunesImage={itunesData && itunesData.artworkUrl600 || podcastInfo && podcastInfo.image || ''}
                showDescription={false} customTextAtTop={'Resume last played Episode'.toUpperCase()}
                podcastEpisodes={podcastEpisodes.items} />} */}

              {showSectionEpisodes && <>
                {!isSleep(podcastInfoGeneric) && <h2 style={{ marginBottom: '4px' }}>Key Ideas</h2>}
                {isBook(podcastInfoGeneric) && <p>
                  <FontAwesomeIcon icon={['fas', 'book-open']} style={{ marginLeft: '0px', fontSize: `16px` }} /> Read | <FontAwesomeIcon icon={['fas', 'headphones']} style={{ marginLeft: '0px', fontSize: `16px` }} /> Listen - Full summary</p>}
                {
                  typeof podcastEpisodes !== 'undefined' && typeof podcastEpisodes.items !== 'undefined' ? podcastEpisodes.items.map((podcastEpisode) => (
                    <article key={podcastEpisode.pubDate + podcastEpisode.title}>
                      <PodcastEpisode podcastEpisode={podcastEpisode} parent='podcast'
                        rawTokenCount={rawTokenCount}
                        popularEpisodesMap={popularEpisodesMap}
                        itunesData={podcastInfoGeneric}
                        itunesImage={itunesData && itunesData.artworkUrl600 || podcastInfo && podcastInfo.image || ''}
                        podcastEpisodes={podcastEpisodes.items} />
                    </article>
                  )) : ''
                }
              </>}
              {loadingReversed && <EpisodeSkeleton />}
              {/* {searchValues == false && (isReversed || currPageEpisodeListType == 'unplayed' || currPageEpisodeListType == 'popular' || currPageEpisodeListType == 'favourites' || currPageEpisodeListType == 'recent') && <div> */}
              {/* {filteredNeededEpisodes.map((podcastEpisode) => (
                <PodcastEpisode key={podcastEpisode.pubDate + podcastEpisode.title} podcastEpisode={podcastEpisode} parent='podcast'
                  popularEpisodesMap={popularEpisodesMap}
                  itunesImage={itunesData && itunesData.artworkUrl600 || podcastInfo && podcastInfo.image || ''}
                  podcastEpisodes={podcastEpisodes.items} />
              ))} */}
              {/* </div>} */}
              {(podcastInfoGeneric.type || 1) == 1 &&
                <div className='' style={{ maxWidth: '600px', margin: 'auto' }}>
                  <br />
                  <h3>About Author</h3>
                  <p>{podcastEpisodes.feed.authorDesc}</p>
                </div>}
            </div>
          </div> : (loadingLatestEpisodes ? <LoadingSpinner /> :
            <>
              <InvalidPodcast message="Sorry we couldn't find this podcast. Please try again or search for a similar podcast." />
              <div style={{ width: '200px', margin: 'auto' }}>
                <SubscribeOption type='button' itunesId={itunesId} podcast={itunesData} showSubscribers={false} onlyshowUnsubscribe={true} />
              </div>
            </>)
          // <p>This is not a valid podcast. Please try another one.</p>
        }
        <style jsx>
          {`
            // h2 {
            //   margin-bottom: ${spacing('xxs')};
            // }
            .title {
              // font-size: ${fontSize('lg')};
              margin-bottom: 0; // ${spacing('xxs')};
              max-width: 800px;
            }
            .news-icon {
              position: absolute;
              top: 6px;
              right: 8px;
              font-size: 14px;
              font-weight: bold;
              color: darkblue;
            }
            .main-img-wrapper {
              position: relative;
              height: 0;
              padding-top: 150%;
              margin-bottom: ${spacing()};
            }
            :global(.main-img) {
              position: absolute;
              top: 0;
              left: 0;
              max-width: 100%;
              height: auto; 
              // width: 100%; // 11vw;
              // height: 100%; // 11vw;
              min-height: calc(1.1*${minImageWidth});
              min-width: calc(1.1*${minImageWidth});
              margin-right: ${spacing('lg')};
              margin-bottom: ${spacing('lg')};
              border-radius: 1em;
              // border: 1px solid ${borderColor};
              box-shadow: 0 20px 40px 0 rgba(0,11,40,.14); // 0 8px 8px rgba(0,0,0,0.30), 0 4px 4px rgba(0,0,0,0.22);
            }
            :global(.box-shadow) {
              box-shadow: 0 4px 4px -2px rgba(0,0,0,.2);
            }
            .header {
              opacity: 0;
            }
            .header.header-visible {
              opacity: 1;
              transition: opacity 600ms 0ms;
            }
              @media ${maxScreenSize.tablet} {
                .main-page {
                  padding-left: 1em;
                  padding-right: 1em;
                }
                            .main-img {
                              margin-right: 0;
                              max-width: 200px;
                              position: relative;
                                    margin-bottom: 0;
                            }
                            .main-img-wrapper {
                              padding-top: 0%;
                              height: auto;
                              text-align: center;
                                    margin-bottom: 0;
                            }
                        }
         
            // .sticky-header{
            //   // position: -webkit-sticky; /* Safari */
            //   // position: sticky;
            //   top: 4.5vw;
            //   position: fixed;
            // }
            `}
        </style>
      </div >
    );
  }
}

podcast.defaultProps = {

  // podcastEpisodes: {
  //   feed: {
  //     title: "",
  //     image: "",
  //     author: ''
  //   }
  // }
};

podcast.propTypes = {
  feedUrl: PropTypes.string,
  podcastEpisodes: PropTypes.object,
  userDetails: PropTypes.object,
  loadingState: PropTypes.object,
  settingsState: PropTypes.object,
  podcastInfoGeneric: PropTypes.object,
  dbPodcastState: PropTypes.object,
  // loadingUserDetails: PropTypes.bool,
  isItBrowser: PropTypes.bool,
  itunesId: PropTypes.number,
  genresArray: PropTypes.array,
  episodePaginationMap: PropTypes.object,
  currPage: PropTypes.string,
  // genresString: PropTypes.string,
  getPodcastData: PropTypes.func,
  setAllEpisodesAsPlayed: PropTypes.func,
  getPopularEpisodesInSeries: PropTypes.func,
  fetchRelatedPodcasts: PropTypes.func,
  fetchRelatedProducts: PropTypes.func,
  personalRatingsValues: PropTypes.object,
  // personalValues: PropTypes.object,
  personalMarkPlayedValues: PropTypes.object,
  allPopularEpisodesData: PropTypes.object,
  audioInfo: PropTypes.object,
  addToAutoQueueInfoFn: PropTypes.func,
  loadMostRecentEpisodeInSeries: PropTypes.func,
  getRecentEpisodesInSeries: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    userDetails: state.userDetails,
    loadingState: state.loadingState,
    audioInfo: state.audioState,
    userPlaylists: state.userPlaylists,
    settingsState: state.settingsState,
    personalRatingsValues: state.personalRatingsValues,
    // personalValues: state.personalValues,
    personalMarkPlayedValues: state.personalMarkPlayedValues,
    allPopularEpisodesData: state.allPopularEpisodesData,
    dbPodcastState: state.dbPodcastState
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // setUserDetails: bindActionCreators(setUserDetails, dispatch),
    // fetchUserSubscriptions: bindActionCreators(fetchUserSubscriptions, dispatch),
    // loadingUserDetailsState: bindActionCreators(loadingUserDetailsState, dispatch),
    getPodcastData: bindActionCreators(getPodcastData, dispatch),
    setAllEpisodesAsPlayed: bindActionCreators(setAllEpisodesAsPlayed, dispatch),
    getPopularEpisodesInSeries: bindActionCreators(getPopularEpisodesInSeries, dispatch),
    fetchRelatedProducts: bindActionCreators(fetchRelatedProducts, dispatch),
    fetchRelatedPodcasts: bindActionCreators(fetchRelatedPodcasts, dispatch),
    addToAutoQueueInfoFn: bindActionCreators(addToAutoQueueInfo, dispatch),
    loadMostRecentEpisodeInSeries: bindActionCreators(loadMostRecentEpisodeInSeries, dispatch),
    getRecentEpisodesInSeries: bindActionCreators(getRecentEpisodesInSeries, dispatch),
  }
};

// export default withRedux(initStore, null, null)(Home)
// export default compose(
//   withRedux(initStore, null, null),
//   connect(mapStateToProps, mapDispatchToProps)
// )(Podcast);

export default connect(mapStateToProps, mapDispatchToProps)(podcast);
